import { action, toJS } from 'mobx';

import Exim from 'exim';
import _ from 'lodash';

import Api from 'tm3-core/api';

import ConfigStore from '../mobx/config-store';
import lazy from './lazy-loader';

const ConfigObservable = new ConfigStore();

const Store = Exim.createStore({
  actions: ['load', 'loadAll', 'refresh', 'setValue', 'getValue'],

  initial() {
    return { config: {} };
  },

  load() {
    this.set({ loadingConfig: true });

    return lazy.item('/api/sys/config/all').then(
      action((res) => {
        const result = res?.body?.result;

        if (!result) return;
        if (!_.isEqual(toJS(ConfigObservable.config), result)) {
          ConfigObservable.update(result);

          return this.set({
            config: result,
            loadingConfig: false
          });
        }
      })
    );
  },

  refresh() {
    lazy.clear();
    return this.actions.load();
  },

  loadAll() {
    return lazy.item('/api/sys/config/all').then((res) => {
      return res?.body?.result;
    });
  },

  getValue(value) {
    return lazy.item('/api/sys/config/all').then((res) => {
      return res?.body?.result?.[value];
    });
  },

  setValue(desc, val) {
    ConfigObservable.updateValue(desc, val);
    if (desc != null) {
      return Api.post('/api/sys/config/update', { Description: desc, Value: val }).then(
        action((res) => {
          const result = res?.body?.result;
          lazy.update('/api/sys/config/all', result);
          ConfigObservable.update(result);
          return this.set({
            config: result
          });
        })
      );
    }
  }
});

Store.ConfigObservable = ConfigObservable;
export default Store;
export { ConfigObservable };
